import React from 'react';
import { SECOND_SCROLL } from '../../data/content';
import { LineRevealOnView } from './Reveal';

export const SecondScroll = () => (
  <section className="py-8 md:py-12">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-12">
        <div className="col-span-12 lg:col-span-10">
          <LineRevealOnView
            lines={[SECOND_SCROLL.emphasis]}
            lineClassName="font-serif italic text-teal text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-[-0.01em]"
          />
        </div>
      </div>
    </div>
  </section>
);
